module.exports = __webpack_public_path__ + "img/gongneng-6.72e983f1.png";